import React from 'react';
import Image from 'react-bootstrap/Image';
import { Link } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class UserRow extends React.Component {

  constructor(props){
    super(props);
  }
  getPlaceText = (place) => {
    let str = place;
    if (place == 1)
      str += "st";
    if (place == 2)
      str += "nd";
    if (place == 3)
      str += "rd";
    else if (place > 3)
      str += "th";
    return str;
  }
  renderAvatar = (user) => {
    if (user.photoURL){
      return(
        <div className="avatar">
          <Image roundedCircle src={user.photoURL} width="40" height="40" alt="Photo" />
        </div>
      );
    }

    else {
      const i = user.displayName.substring(0,1);
      return(
        <div className="avatar"> {i} </div>
      );

    }
  }


  render(){

    const u = this.props.user;

    return(

      <div className="prow">

        {this.renderAvatar(u)}

        <div style={{marginLeft:'10px'}} >

          <div className="lbDisplayName">{u.displayName}</div>

          <div className="lbHometown">{u.homeTown}</div>

        </div>

      </div>

    );

  }

}
